import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { LockSystem } from "@/api/lockSystems/lockSystems.ts";
import { LockSystemModal } from "./modals/lockSystemModal";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function LockSystemChip({ lockSystemId }: { lockSystemId: number }) {
  const [item, setItem] = useState<LockSystem | null>(null);
  const items = useAppSelector((state) => state.handbooks.lockSystem);
  const disclosure = useDisclosure();

  useEffect(() => {
    if (lockSystemId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == lockSystemId) || null);
    }
  }, [lockSystemId, items]);

  return (
    <>
      <LockSystemModal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        item={item!}
      />
      {lockSystemId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {lockSystemId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {lockSystemId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
